export default {
  title: "Cliquez ou déposez un fichier ici pour l'importer",
  description: 'Formats acceptés : .csv, .xls, .xlsx',
  buttons: {
    download_template: "Télécharger le modèle d'importation",
  },
  toasts: {
    error: 'Échec du téléchargement du fichier',
  },
};
